import {
    UI_AUTO_TEST_RESULTS_PATH,
    UI_BOOKING_PATH,
    UI_DASHBOARDS_PATH,
    UI_DATASHEETS_CHARTS_PATH,
    UI_DATASHEETS_PATH,
    UI_DATASHEETS_TABLE_PATH,
    UI_DEFECTS_PATH,
    UI_EXECUTION_PATH,
    UI_FUNCTIONAL_TESTING_PATH,
    UI_HAND_TEST_RESULTS_PATH,
    UI_HISTORY_PATH,
    UI_LIBRARY_PATH,
    UI_MODULES_PATH,
    UI_PERFORMANCE_PATH,
    UI_PROFILE_PATH,
    UI_SCHEMES_PATH,
    UI_STANDS_PATH,
    UI_TEST_CASE_PATH,
    UI_TEST_PLAN_PATH,
    UI_TEST_RUN_PATH,
} from './pathsConstants';

export const EXECUTION_DASHBOARD_ROUTE = `/${UI_DASHBOARDS_PATH}/${UI_EXECUTION_PATH}`;
export const PERFORMANCE_DASHBOARD_ROUTE = `/${UI_DASHBOARDS_PATH}/${UI_PERFORMANCE_PATH}`;
export const DATASHEETS_DASHBOARD_ROUTE = `/${UI_DASHBOARDS_PATH}/${UI_DATASHEETS_PATH}`;
export const DATASHEETS_DASHBOARD_CHARTS_ROUTE = `${UI_DASHBOARDS_PATH}/${UI_DATASHEETS_PATH}/${UI_DATASHEETS_CHARTS_PATH}`;
export const DATASHEETS_DASHBOARD_TABLE_ROUTE = `${UI_DASHBOARDS_PATH}/${UI_DATASHEETS_PATH}/${UI_DATASHEETS_TABLE_PATH}`;
export const MODULES_ROUTE = `/${UI_MODULES_PATH}/*?`;
export const TESTCASES_ROUTE = `/${UI_FUNCTIONAL_TESTING_PATH}/${UI_TEST_CASE_PATH}`;
export const TESTCASE_ROUTE = `${TESTCASES_ROUTE}/:testcaseId`;
export const TESTCASE_HISTORY_ROUTE = `${TESTCASE_ROUTE}/${UI_HISTORY_PATH}`;
export const TESTPLANS_ROUTE = `/${UI_FUNCTIONAL_TESTING_PATH}/${UI_TEST_PLAN_PATH}`;
export const TESTPLAN_ROUTE = `${TESTPLANS_ROUTE}/:testplanId`;
export const TESTPLAN_HISTORY_ROUTE = `${TESTPLAN_ROUTE}/${UI_HISTORY_PATH}`;
export const TESTRUNS_ROUTE = `/${UI_FUNCTIONAL_TESTING_PATH}/${UI_TEST_RUN_PATH}`;
export const TESTRUN_ROUTE = `${TESTRUNS_ROUTE}/:testrunId`;
export const TESTRESULT_AUTO_ROUTE = `/${UI_FUNCTIONAL_TESTING_PATH}/${UI_AUTO_TEST_RESULTS_PATH}/:testResultId`;
export const TESTRESULT_HAND_ROUTE = `/${UI_FUNCTIONAL_TESTING_PATH}/${UI_HAND_TEST_RESULTS_PATH}/:testResultId`;
export const SCHEMES_ROUTE = `/${UI_SCHEMES_PATH}`;
export const SCHEMES_FAVORITES_ROUTE = `${SCHEMES_ROUTE}/favorites`;
export const SCHEME_SCRATCH_ROUTE = `${SCHEMES_ROUTE}/scratch`;
export const SCHEME_ROUTE = `${SCHEMES_ROUTE}/:schemeId`;
export const SCHEME_EDIT_ROUTE = `${SCHEME_ROUTE}/edit`;
export const PROFILE_ROUTE = `/${UI_PROFILE_PATH}/:userId`;
export const LIBRARY_ROUTE = `/${UI_LIBRARY_PATH}`;
export const BOOKING_ROUTE = `/${UI_BOOKING_PATH}`;
export const BOOKING_FAVORITES_ROUTE = `${BOOKING_ROUTE}/favorites`;
export const BOOKING_MY_ROUTE = `${BOOKING_ROUTE}/my`;
export const STANDS_ROUTE = `/${UI_STANDS_PATH}`;
export const DEFECTS_ROUTE = `/${UI_DEFECTS_PATH}/:defectId?`;
